<script>
import { Line } from 'vue-chartjs'
import { Chart } from 'chart.js'
import Utils from "../../../config/utils";

export default {
  extends: Line,
  props:['label', 'chartData', 'options'],
  mounted () {
    
    let labels = [];
    let data = [];
    for (let i = 0; i < this.chartData.length; i++) {
      labels.push("‘" + this.chartData[i].f_pbdate.substr(2, 2))
      data.push(this.chartData[i].f_totarea * this.chartData[i].f_pbprice);
    }
    
    var dataCollection = {
      labels: labels,
      datasets: [
        {
          label: this.label,
          data: data,
          fill: false,
          borderColor: "rgb(38, 127, 255)",
          tension: 0,
          pointRadius: 4,
          pointHoverRadius: 4,
          pointHitRadius: 4,
          pointBorderWidth: 0,
          pointHoverBorderWidth: 0,
          pointBackgroundColor: "rgb(38, 127, 255)",
          pointHoverBackgroundColor: "rgb(38, 127, 255)",
          borderWidth: 2,
        }
      ],
    };

    Chart.Tooltip.positioners.custom = function(elements, eventPosition) {
        /** @type {Chart.Tooltip} */
        var tooltip = this;

        /* ... */

        return {
            x: elements[0]._view.x,
            y: 0
        };
    };
    var options = {
      layout: {
        padding: {
          right: 0
        }
      },
      legend: {
        display: false,
      },
      events: ['click'],
      tooltips: {
        mode: 'index',
        position: 'custom',
        intersect: false,
        backgroundColor: 'transparent',
        titleSpacing: 0,
        titleMarginBottom: 0,
        padding: 0,
        caretPadding: 0,
        caretSize: 0,
        boxPadding: 0,
        footerSpacing: 0,
        footerMarginTop: 0,
        bodySpacing: 0,
        titleFontFamily: 'KoreanGD15R',
        // titleFontSize: '15',
        titleFontColor: 'black',
        callbacks: {
          title: function(item, data) {
            return data.labels[item[0].index] + ". 01";
          },
          label: function(tooltipItem, data) {
            return '';
          }
        }
      },
      hover: {
        mode: 'nearest',
        intersect: true
      },
      scales: {
        xAxes : [{
          gridLines: {
            display: true,
            drawTicks:false,
            color: 'transparent',
            zeroLineColor: 'rgb(193, 214, 252)',
            zeroLineWidth: 1,
            drawBorder: false,
          },
          ticks: {
            display: true,
            beginAtZero: true,
            // maxTicksLimit: 20,
            maxRotation: 0,
            fontFamily: 'KoreanGD13R',
            fontSize: 13,
          },
        }],
        yAxes : [{
          afterFit: (scale) => {
            console.log(scale);
            scale.width = 50;
            // if (scale._labelItems.length > 0) {
            //   scale._labelItems[0].textAlign = 'left';
            // }
          },
          gridLines: {
            display:true,
            drawTicks:false,
            color: 'transparent',
            zeroLineColor: 'rgb(193, 214, 252)',
            zeroLineWidth: 1,
            drawBorder: false,
          },
          ticks: {
            display: true,
            beginAtZero: true,
            fontFamily: 'KoreanGD13R',
            fontSize: 13,
            callback: function(value, index, ticks) {
              if (value == 0) return '';
              if (value < 10000) {
                return Math.round(value).toString();
              } else if (value >= 100000000) {
                return (value / 100000000.0).toFixed(2).toString() + "억";
              } else {
                return Utils.currency(Math.round(value / 10000)) + "만";
              }
            }
          }
        }]
      },
    }

    this.addPlugin({
      id: 'customLine',
      afterDatasetsDraw: (chart) => {
        if (chart.tooltip._active && chart.tooltip._active.length) {
          const activePoint = chart.tooltip._active[0];
          const ctx = chart.ctx;
          const x = activePoint.tooltipPosition().x;
          const y = activePoint.tooltipPosition().y;
          const topY = chart.scales['y-axis-0'].top + 10;
          const bottomY = chart.scales['y-axis-0'].bottom;
          // Draw vertical line
          ctx.save();
          ctx.beginPath();
          ctx.strokeStyle = '#000000';
          ctx.lineWidth = 2;
          ctx.moveTo(x, topY);
          ctx.lineTo(x, bottomY);
          ctx.stroke();
          // Draw circle
          // ctx.beginPath();
          // ctx.arc(x, y, 6, 0, 2 * Math.PI);
          // ctx.fillStyle = "#2d66eb";
          // ctx.fill();
          // ctx.lineWidth = 0;
          // ctx.strokeStyle = "#2d66eb";
          // ctx.stroke();
          // ctx.restore();
        }
      }
    });
    this.addPlugin({
      id: 'customClick',
      afterEvent: (chart, evt, opt) => {
        let activePoints = chart.getElementsAtEventForMode(evt, 'index', {intersect: false});
        if (activePoints.length > 0) {
          let idx = activePoints[0]._index;
          this.$emit('onClick', idx);
        }
      }
    });
    this.renderChart(dataCollection, options);

    this.selectTip(this.chartData.length - 1);
    this.eventBus.$on("draw_line", this.drawLine);
  },
  inject: ["eventBus"],
  methods: {
    selectTip(idx) {
      setTimeout(() => {
        var chart = this.$data._chart;
        var canvas = chart.chart.chart.canvas;
        if (canvas == null) return;
        var boundingRect = canvas.getBoundingClientRect();
        var points = chart.getDatasetMeta(0).data;
        var point = points[idx];
        var mouseX = Math.round((boundingRect.left + point._view.x) / (boundingRect.right - boundingRect.left) * canvas.width / chart.chart.chart.currentDevicePixelRatio);
        var mouseY = Math.round((boundingRect.top + point._view.y) / (boundingRect.bottom - boundingRect.top) * canvas.height / chart.chart.chart.currentDevicePixelRatio);
        var oEvent = document.createEvent('MouseEvents');
        oEvent.initMouseEvent('click', true, true, document.defaultView,
            0, mouseX, mouseY, mouseX, mouseY,
            false, false, false, false, 0, canvas);
        canvas.dispatchEvent(oEvent);
      }, 500);
    },
    drawLine(idx) {
      this.selectTip(idx);
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/controls/popup/LineChart3.vue